import colors from '../../../theming/themes/alucio/colors';
import React, { useState } from 'react';
import { StyleSheet, Pressable, ScrollView } from 'react-native';
import { luxColors, DNADivider, DNAIcon, Icon, DNABox, DNAText } from '../../../index';
const S = StyleSheet.create({
    Container: {
        marginTop: 16,
        width: 392,
        borderRadius: 4,
        borderColor: luxColors.formFieldBorder.primary,
        borderWidth: 1,
    },
    NotificationRow: {
        paddingVertical: 12,
    },
    NotificationDetailsToggleLabel: {
        width: 110,
        marginTop: 5,
    },
    Highlight: {
        backgroundColor: 'rgba(48,173,127,0.08)',
        borderColor: '#D6EFE5',
        borderWidth: 1,
    },
    Icon: {
        width: 20,
        height: 20,
        color: colors['color-gray-500'],
    },
    IconHighlight: {
        color: luxColors.warning.quaternary,
    },
    IconNotification: {
        width: 22,
        height: 22,
        color: luxColors.basicBlack.primary,
    },
    NotificationAction: {
        color: luxColors.primary.primary,
    },
    NotificationActionLabel: {
        marginRight: 16,
    },
    NotificationSecondary: {
        color: luxColors.basicBlack.secondary,
    },
    NotificationPrimary: {
        color: '#494949',
    },
    NotificationHighlight: {
        color: luxColors.success.tertiary,
    },
    NotificationsContainer: {
        borderRadius: 8,
        padding: 16,
        backgroundColor: luxColors.info.primary,
        borderWidth: 0,
        shadowColor: luxColors.basicBlack.primary,
        shadowOffset: {
            width: 0,
            height: 4,
        },
        shadowOpacity: 0.16,
        shadowRadius: 11.22,
        width: 440,
        maxHeight: 540,
    },
    NotificationsScroll: {
        maxHeight: 460,
    },
});
const DNANotificationsItem = (props) => {
    const { actionLabel, date, details, highlight, icon, onPress, shortDescription, } = props;
    const [detailsVisible, setDetailsVisible] = useState(false);
    const dateStyle = highlight ? S.NotificationHighlight : S.NotificationSecondary;
    const descriptionStyle = highlight ? S.NotificationHighlight : S.NotificationPrimary;
    const actionStyle = highlight ? S.NotificationHighlight : S.NotificationAction;
    const toggleDetails = (event) => {
        event.stopPropagation();
        setDetailsVisible(visible => !visible);
    };
    const pressDetail = (event, onPress) => {
        event.stopPropagation();
        onPress();
    };
    return (<DNABox appearance="col" style={[S.Container, highlight && S.Highlight]}>
      <Pressable onPress={onPress} disabled={!onPress}>
        <DNABox appearance="row" alignY="center" spacing="xs" childFill={1} style={S.NotificationRow}>
          <DNABox alignX="center" alignY="center" style={{ width: 56 }}>
            <Icon style={[S.Icon, highlight && S.IconHighlight]} name={icon}/>
          </DNABox>

          <DNABox appearance="col" alignY="center">
            <DNAText caption style={[dateStyle, { fontSize: 11, lineHeight: 20 }]}>
              {date.toUpperCase()}
            </DNAText>
            <DNAText bold={highlight} style={descriptionStyle}>
              {shortDescription}
            </DNAText>
            {!!details?.length && (<Pressable onPress={toggleDetails}>
                <DNABox appearance="row" alignY="center" spacing="xs">
                  <DNAText caption status="secondary" style={S.NotificationDetailsToggleLabel}>
                    {detailsVisible
                ? 'Hide folders'
                : `${details.length} folder${details.length === 1 ? '' : 's'} updated`}
                  </DNAText>
                  <DNAIcon.Styled name={detailsVisible ? 'caret-up' : 'caret-down'} status="tertiary" width={16} height={16}/>
                </DNABox>
              </Pressable>)}
            {!!details?.length && detailsVisible && (<DNABox appearance="col" spacing="xs">
                {details.map(detail => (<Pressable key={detail.id} onPress={event => pressDetail(event, detail.onPress)}>
                    <DNAText numberOfLines={1} style={S.NotificationAction}>
                      {detail.label}
                    </DNAText>
                  </Pressable>))}
              </DNABox>)}
          </DNABox>
          {!!actionLabel && (<DNABox appearance="col" alignX="end" alignY="center">
              <DNAText style={[actionStyle, S.NotificationActionLabel]}>
                {`${actionLabel} >`}
              </DNAText>
            </DNABox>)}
        </DNABox>
      </Pressable>
    </DNABox>);
};
const DNANotifications = (props) => {
    const { onPress, items } = props;
    return (<DNABox appearance="col" style={S.NotificationsContainer}>

      <Pressable onPress={onPress}>
        <DNABox appearance="row" alignY="center">
          <DNAText testID="notification-nav-button" h5>Notifications</DNAText>
          <DNAIcon.Styled name="caret-right" status="tertiary"/>
        </DNABox>

      </Pressable>

      <DNADivider style={{ marginTop: 16 }}/>
      <ScrollView showsVerticalScrollIndicator={false} style={S.NotificationsScroll}>
        {items.map(item => (<DNANotificationsItem key={item.id ?? `${item.date}-${item.shortDescription}`} {...item}/>))}
      </ScrollView>
    </DNABox>);
};
export default DNANotifications;
//# sourceMappingURL=DNANotifications.js.map